class ApiErrorSerializer {
  static deSerialize(data) {
    // return {
    //   code: data.Codigo && data.Codigo === '1029' ? '1035' : data.Codigo,
    //   message: data.Mensaje && data.Codigo === '1029' ? 82 : data.Mensaje,
    //   content: data.Contenido || null,
    // };
    return {
      code: data.Codigo || null,
      message: data.Mensaje || null,
      content: data.Contenido || null,
    };
  }
}

export { ApiErrorSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/ApiErrorSerializer.js